import { useCallback, useEffect, useState } from "react";

import { getCompletedCoursesByUser } from "../helpers/tracking.helper";
import useContactRelation from "./contactRelation.hook";

/**
 * Hook que devuelve los cursos completados por el usuario logueado.
 *
 * Una sola llamada al backend (`/tracking/getCompletedCoursesByUser`,
 * Q11-sexies) — antes había que iterar `getCompleted` por curso, N
 * llamadas. Sin sesión devuelve lista vacía sin llamar a la red.
 */
const useCompletedCourses = () => {
  const { token, userLocal } = useContactRelation();
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!token || !userLocal?.id) {
      setIsLoading(false);
      return;
    }
    let cancelled = false;
    (async () => {
      const response = await getCompletedCoursesByUser(userLocal.id, token);
      if (!cancelled) {
        setData(response);
        setIsLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [token, userLocal?.id]);

  return { data, isLoading };
};

export default useCompletedCourses;
